import React, { useState, useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { BsSearch } from 'react-icons/bs';
import Button from 'components/inputs/Button';
import Switch from 'components/inputs/Switch';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Row, Col, Modal } from 'react-bootstrap';
import * as _ from 'lodash';
import moment from 'moment';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from 'components/general/Pagination';
import { startsWith } from 'components/common/utils';
import { DELETE_WHATSNEW, FETCH_WHATSNEW, GET_WHATSNEW, UPDATE_WHATSNEW } from 'actions/whatsNew';
import WhatsNewForm from './WhatsNewForm';

const fmt = (d) => (d ? moment(d).format('DD MMM YYYY') : '-');

const WhatsNewList = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [allData, setAllData] = useState([]);

  const page = useSelector((state) => state.whatsNew.page);
  const totalData = useSelector((state) => state.whatsNew.total);
  const limit = useSelector((state) => state.whatsNew.limit);
  const list = useSelector((state) => state.whatsNew.whatsNewList);

  const deleteItem = useCallback((id) => dispatch({ type: DELETE_WHATSNEW.REQUEST, payload: id }), []);
  const getList = useCallback((data = {}) => dispatch({ type: FETCH_WHATSNEW.REQUEST, payload: data }), []);
  const getDetail = useCallback((id) => dispatch({ type: GET_WHATSNEW.REQUEST, payload: id }), []);
  const toggleActive = useCallback(
    (id, isActive) => dispatch({ type: UPDATE_WHATSNEW.REQUEST, payload: { id, is_active: isActive } }),
    []
  );

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    setAllData(_.filter(list, (item) => startsWith(_.get(item, 'release_version', ''), searchText)));
  }, [searchText, list]);

  const handlePageClick = (pageVal) => getList({ page: pageVal });

  const handleClose = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title="What's New" />
        <div className="page-content-wrapper scrollable">
          <div className="faqList-page">
            <Card>
              <div className="faqList-page-wrapper">
                <Row className="faqList-search-box">
                  <Col xl={10} lg={9} md={8} className="faqList-search-inputBox">
                    <SearchBox value={searchText} preIcon={<BsSearch />} onChange={(e) => setSearchText(e.target.value)} />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="faqList-search-boxButton">
                    <Button
                      className="faqList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      Add What&apos;s New
                    </Button>
                  </Col>
                </Row>
                <div className="faqList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th>Version</th>
                          <th>Status</th>
                          <th>Date Range</th>
                          <th>Slides</th>
                          <th className="action-col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {_.isEmpty(allData) ? (
                          <tr>
                            <td colSpan={5} className="border-0">
                              <div className="empty-data-block">No What&apos;s New found</div>
                            </td>
                          </tr>
                        ) : (
                          _.map(allData, (item, key) => (
                            <tr key={`whatsNew-${key}`}>
                              <td>{_.get(item, 'release_version', '')}</td>
                              <td>
                                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                  <Switch
                                    checked={!!_.get(item, 'is_active')}
                                    onChange={(checked) => toggleActive(_.get(item, 'id', ''), checked)}
                                  />
                                  <span>{_.get(item, 'is_active') ? 'Active' : 'Inactive'}</span>
                                </div>
                              </td>
                              <td>
                                {fmt(_.get(item, 'start_date'))} - {fmt(_.get(item, 'end_date'))}
                              </td>
                              <td>{_.size(_.get(item, 'slides', []))}</td>
                              <td>
                                <span
                                  className="faqList-table-editIcon"
                                  onClick={() => {
                                    setShowForm(true);
                                    getDetail(_.get(item, 'id', ''));
                                    setIsEdit(true);
                                  }}
                                >
                                  <FiEdit2 title="Edit" />
                                </span>
                                <span className="faqList-table-deleteIcon" onClick={() => deleteItem(_.get(item, 'id', ''))}>
                                  <RiDeleteBinLine title="Delete" />
                                </span>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {!_.isEmpty(allData) && (
                  <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                )}
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="xl" centered>
            <WhatsNewForm onClose={handleClose} isEdit={isEdit} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};

export default WhatsNewList;
